// extracted by mini-css-extract-plugin
export default {"smBreak":"600px","tabs":"FoPYbfzTiFlUuZtWacVD"};